import api from "./api";

/** Convert base64 URL-safe key (VAPID) to a Uint8Array (Web Push spec). */
function urlB64ToUint8Array(b64) {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function ensureServiceWorker() {
  if (!("serviceWorker" in navigator)) throw new Error("Service worker non supportato");
  return await navigator.serviceWorker.register("/sw.js");
}

export async function getCurrentSubscription() {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return null;
  return await reg.pushManager.getSubscription();
}

export async function subscribeAdminForPush() {
  if (!isPushSupported()) throw new Error("Browser non supportato per le notifiche push");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso notifiche negato");
  const { data } = await api.get("/push/vapid-public-key");
  if (!data?.key) throw new Error("Chiave VAPID non configurata sul server");
  const reg = await ensureServiceWorker();
  await navigator.serviceWorker.ready;
  const existing = await reg.pushManager.getSubscription();
  if (existing) await existing.unsubscribe();
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlB64ToUint8Array(data.key),
  });
  const json = sub.toJSON();
  await api.post("/admin/push/subscribe", {
    endpoint: json.endpoint,
    keys: json.keys,
    ua: navigator.userAgent,
  });
  return sub;
}

export async function unsubscribeAdminFromPush() {
  const sub = await getCurrentSubscription();
  if (!sub) return;
  const json = sub.toJSON();
  try {
    await api.delete("/admin/push/subscribe", { data: { endpoint: json.endpoint, keys: json.keys } });
  } catch (_) { /* server may already be clean */ }
  await sub.unsubscribe();
}

export async function sendPushTest() {
  const { data } = await api.post("/admin/push/test");
  return data;
}
